import Route from '@ember/routing/route'

export default class BookingConfirmationRoute extends Route {}
